<template>
  <div class="checkout-footer-main">
    <div class="checkout-footer-main-logo">
      <component
        :is="currentPath === siteDir ? 'span' : 'a'"
        :href="currentPath === siteDir ? null : siteDir"
        class="checkout-footer-main-logo__link"
      >
        <svg><use xlink:href="#svg-logo-high"></use></svg>
      </component>
    </div>
    <div class="checkout-footer-block">
      <div class="checkout-footer-item">
        <h6 class="checkout-footer-item__title">{{ messages.eShopPhone }}</h6>
        <a class="checkout-footer-item__text" :href="'tel:' + result.eShopPhone">{{
          result.eShopPhone
        }}</a>
      </div>
      <div class="checkout-footer-item">
        <h6 class="checkout-footer-item__title">{{ messages.eShopServicePhone }}</h6>
        <a class="checkout-footer-item__text" :href="'tel:' + result.eShopServicePhone">{{
          result.eShopServicePhone
        }}</a>
      </div>
      <div class="checkout-footer-item">
        <h6 class="checkout-footer-item__title">Email:</h6>
        <a
          class="checkout-footer-item__text"
          :href="'mailto:' + result.eShopMail + '?subject=' + result.messages.eShopMailSubject"
        >
          {{ result.eShopMail }}
        </a>
      </div>
      <div class="footer-times" v-html="result.eShopTimeTable"></div>
      <div class="checkout-footer-item">
        <h6 class="checkout-footer-item__title">
          <span>{{ messages.eShopSocialMedia }}</span>
        </h6>
        <DefSocial />
      </div>
      <FooterCountries />
    </div>
  </div>
</template>

<script lang="ts" setup>
import FooterCountries from '@components/Footer/FooterCountries.vue';
import { computed, ref } from 'vue';
import DefSocial from '@components/Def/DefSocial/DefSocial.vue';
import { useResultsStore } from '@/storePinia/stores/results';

const resultsStore = useResultsStore();

const currentPath = ref(window.location.pathname);

const result = computed(() => resultsStore.storeInformation);
const messages = computed(() => resultsStore.storeInformation.messages);
const siteDir = computed(() => resultsStore.siteLanguages?.siteDir);
</script>

<style lang="scss" scoped>
.checkout-footer-main {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 24px;
  padding: 24px 0;
  @include point-md {
    grid-template-columns: 70px minmax(0, 1fr);
    gap: 100px;
    padding: 32px 0 24px;
  }
  @include point-xl {
    grid-template-columns: 105px minmax(0, 1fr);
    gap: 105px;
    padding: 40px 0 32px;
  }
  :deep(.footer-times) {
    display: grid;
    grid-row-gap: 4px;

    .footer-times__title {
      font-size: 14px;
      font-weight: 600;
      line-height: 125%;
      color: rgba(255, 255, 255, 0.7);
    }

    .footer-times__hours {
      font-size: 16px;
      font-weight: 500;
      line-height: 125%; /* 20px */
    }
  }
  :deep(.def-social__icon) {
    fill: #fff;
  }
  :deep(.footer-countries) {
    margin-top: 8px;
    @include point-lg {
      margin-top: 0;
    }
  }
}
.checkout-footer-main-logo {
  &__link {
    display: inline-block;
  }
  svg {
    width: 50px;
    height: 72px;
    fill: #fff;
    @include point-md {
      width: 70px;
      height: 100px;
    }
    @include point-xl {
      width: 105px;
      height: 150px;
    }
  }
}
.checkout-footer-block {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 16px;
  align-items: flex-start;
  @include point-md {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px 32px;
  }
  @include point-xl {
    gap: 16px 84px;
    grid-template-columns: repeat(5, minmax(0, max-content));
  }
}
.checkout-footer-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  line-height: 125%;
  &__title {
    font-size: 14px;
    font-weight: 600;
    line-height: 125%;
    color: rgba(255, 255, 255, 0.7);
    margin-bottom: 0;
  }
  &__text {
    font-size: 16px;
    font-weight: 500;
  }
  :deep(.def-social) {
    margin-top: 4px;
  }
}
</style>
